/*=========================================================================================
  M.Djezou
  File Name: moduleRubriqueDepenseState.js
  Description: Rubrique Depense Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  rubriques: []
}